module.exports = __webpack_public_path__ + "static/media/zu2.d09d96bb.png";